import {TransportProvider as ConnectTransportProvider} from '@connectrpc/connect-query';
import {ConnectTransportOptions, createConnectTransport} from '@connectrpc/connect-web';
import {variables} from '@/environment/api';

const transportOptions: ConnectTransportOptions = {
  baseUrl: variables.RPC_BASE_URL.value,
  useBinaryFormat: false,
};

const transport = createConnectTransport(transportOptions);

function TransportProvider({children}: React.PropsWithChildren) {
  return <ConnectTransportProvider transport={transport}>{children}</ConnectTransportProvider>;
}

export {transport, TransportProvider};
